<template>
  <component :is="layout" />
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { notifications_store, polls_store } from '@/store';
import { VueConstructor } from 'vue';
import { Layouts } from '../types';

const { actions } = notifications_store;

@Component
export default class AppLayout extends Vue {
  async mounted() {
    await actions.get_last_notifs();
    await actions.get_last_notifs(true);
    await polls_store.actions.get_polls();
  }

  layout_component: VueConstructor<Vue> | null = null;

  async load_layout_component(layout: string) {
    this.layout_component = (await import(/* webpackChunkName: "layout" */ `@/layouts/${layout}.vue`)).default;
  }

  get layout() {
    if (!this.$route.name) {
      return '';
    }

    const layout = this.$route.meta?.layout || Layouts.DEFAULT;

    if (!this.layout_component || this.layout_component.name !== layout) {
      this.load_layout_component(layout);
    }

    return this.layout_component || null;
  }
}
</script>
